// useGoogleScript.js
import { useEffect, useState } from "react";

export default function useGoogleScript() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (window.google?.accounts?.id) { setReady(true); return; }
    const s = document.createElement("script");
    s.src = "https://accounts.google.com/gsi/client";
    s.async = true;
    s.defer = true;
    s.onload = () => setReady(true);
    document.head.appendChild(s);
    return () => { document.head.removeChild(s); };
  }, []);
  return ready;
}
